<template>
  <div>
    <el-dialog custom-class="editor-dialog" :center="center" :close-on-click-modal="closeOnClickModal" :width="dialogWidth" :visible="dialogVisible" top="5vh"
      :z-index="2000" :before-close="handleClose" @open="onDialogOpen">
      <template #title>
        <span>{{ `${titlePrefix}讲解视频` }}</span>
      </template>
      <template #footer>
        <div class="dialog-footer popup-footer">
          <el-row>
            <el-col :span="12" class="footer-left">
              <el-button v-if="activeStep > 0" :disabled="readonly || isSaving" :loading="isSaving" @click="gotoPrevStep">上一步</el-button>
              <span v-else>&nbsp;</span>
            </el-col>
            <el-col :span="12" class="footer-right">
              <div v-if="isResending">
                <el-button :disabled="readonly || isSaving" :loading="isSaving" type="primary" @click="doResendEmailVideo">重发</el-button>
              </div>
              <div v-else>
                <el-button v-if="activeStep < 1" :disabled="readonly || isSaving" :loading="isSaving" @click="gotoNextStep">下一步</el-button>
                <el-button v-else :disabled="readonly || isSaving" :loading="isSaving" type="primary" @click="saveChanges">确认</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
      <div class="backgroud-white cs-editor-content">
        <studentSelector v-show="activeStep === 0" key="studentSelector" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :readonly="readonly"
          :courseType="courseType" :courseKey="courseKey" :isResending="isResending" :isEdit="isEdit" :data="model" />
        <div v-show="activeStep === 1">
          <el-form key="form" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :rules="rules" :model="model" label-width="150px">
            <el-form-item label="标题" prop="Title">
              <el-input placeholder="请输入标题" :disabled="readonly" v-model="model.Title" class="input-width" />
            </el-form-item>
            <el-form-item label="内容类别" prop="ContentCategory">
              <el-select
                v-model="model.ContentCategory"
                :disabled="readonly"
                placeholder="请选择内容类别"
                class="input-width"
                @change="onContentCategoryChange"
              >
                <el-option
                  v-for="item in contentCategoryOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="model.ContentCategory === EmailVideoContentCategory.GradedOrExam"
              label="过期时间"
              prop="ExpirationTime"
              required
            >
              <el-date-picker
                align="center"
                format="yyyy/MM/dd"
                value-format="yyyy-MM-dd"
                v-model="model.ExpirationTime"
                type="date"
                :disabled="readonly"
                placeholder="请选择过期时间"
              />
              <div class="cs-emailVideoEditor-expirationHint">（建议放学校Due Date当天）</div>
            </el-form-item>
            <el-form-item label="视频文件" prop="Files">
              <el-row v-if="model.VideoPlatform === GLOBAL.enumVideoPlatform.AliyunVod">
                <el-col v-if="!!aliyunVideoInfo">
                  <a href="javascript:;" @click="onVideoView">
                    <span>{{ aliyunVideoInfo.SourceFileName }}</span>
                  </a>
                </el-col>
              </el-row>
              <el-row v-else>
                <el-col v-if="!!sproutVideoFile">
                  <a href="javascript:;" @click="onVideoView">
                    <span>{{ sproutVideoFile.SourceFileName }}</span>
                  </a>
                </el-col>
              </el-row>
              <el-button v-if="!readonly" size="mini" type="primary" plain @click="onVideoUploadClick">本地上传</el-button>
            </el-form-item>

            <el-form-item label="上传文件" prop="value">
              <div>
                <el-row class="cs-emailVideoEditor-file" v-for="(item, itemIndex) in model.Files" :key="itemIndex">
                  <el-col>
                    <a href="javascript:;" @click="downloadEmailFile(item.Id)">
                      <span>{{item.FileName}}</span>
                    </a>
                    <el-button v-if="!readonly" type="text" size="mini" class="cs-redLabel" @click="removeFile(item)">删除</el-button>
                  </el-col>
                </el-row>
              </div>
              <el-button plain size="mini" type="primary" @click="uploadFile()">添加文件</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="上传视频" :center="true" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="sproutVideoUploadVisible"
      :before-close="onBeforeClose" top="8vh" width="600px">
      <sproutVideoUpload :type="1" :dataIn="sproutVideoUploadData" @success="onVideoUploadSuccess" @beforeUpload="onBeforeUpload"
        @fileUploadError="onFileUploadError" />
    </el-dialog>
    <el-dialog title="上传视频-阿里云" :center="true" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="aliyunVodUploadVisible"
      :before-close="onBeforeClose" top="8vh" width="600px">
      <aliyunVodUpload :type="1" :dataIn="aliyunVodUploadData" @success="onVideoUploadSuccess" @beforeUpload="onBeforeUpload"
        @fileUploadError="onFileUploadError">
      </aliyunVodUpload>
    </el-dialog>
    <el-dialog v-if="sproutVideoViewVisible" title="视频" :center="true" :close-on-click-modal="false" :visible.sync="sproutVideoViewVisible" top="8vh"
      width="630px">
      <div v-html="!!sproutVideoFile ? sproutVideoFile.SproutVideoPath : String.empty" />
    </el-dialog>
    <el-dialog center title="上传课件" :show-close="true" :close-on-click-modal="false" width="700px" :visible.sync="coursewareUploaderVisible" top="8vh"
      z-index="2000">
      <blobUploader @closeEditor="onCloseUploader" @blobUploadError="onUploadError" @blobUploaded="onUploaded" :type="18"
        :accepts="'.pdf,.html,.css,.js,.py,.c,.cc,.cpp,.rmd,.rkt,.xls,.xlsx,.sas,.sql,.zip,.rar'" :maxNameLength="32" :isVisible="coursewareUploaderVisible"
        :isMulti="true" :isAutoSave="true"></blobUploader>
    </el-dialog>

    <el-dialog class="cs-aliyunVideo-container" v-if="aliyunVideoViewVisible" :center="true" :close-on-click-modal="false"
      :visible.sync="aliyunVideoViewVisible" @close="onCloseAliyunVideo" top="8vh" width="900px">
      <aliyunVideoPlayer
        v-if="aliyunVideoInfo"
        :videoInfo="aliyunVideoInfo"
        height="600px"
        :hideErrorMessage="hideAliyunVideoPlayerError"
        @play="onAliyunVideoPlayerPlay"
        @pause="onAliyunVideoPlayerPause"
      />
    </el-dialog>
  </div>
</template>

<script>
import { EmailVideo, EmailVideoContentCategory } from "@/model/emailVideo";
import {
  getEmailVideo,
  isEmailVideoTitleExist,
  saveEmailVideo,
  resendEmailVideo,
} from "../../service/emailVideo.service";
import { getSproutVideoFile } from "@/service/videoAppointment.service";
import { getAliyunVodVideoInfo } from "@/service/alibabaCloud.service";
import {
  getBlobFileUrlById,
  downloadFileToBlob,
} from "@/service/blobStorage.service";
import { downloadFile } from "@/config/mUtils";
import { resetTerm } from "../../service/common.service";
let moment = require("moment");

const mixinGeneralMethods = {
  data() {
    return {
      activeStep: 0,
    };
  },
  methods: {
    gotoNextStep() {
      if (this.activeStep >= 1) return;

      let isValid = true;
      let refCom = this.$vueRefStore.getChildrenRef("studentSelector");
      if (!!refCom) {
        isValid = refCom.validate();
      }
      if (!isValid) return;

      this.activeStep += 1;
    },
    gotoPrevStep() {
      if (this.activeStep <= 0) return;
      this.activeStep -= 1;
    },
    validateAsync(callback) {
      if (Object.typeOf(callback) !== "function")
        throw new Error("未指定回调函数");

      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.validate((valid) => {
          let isValid = valid;

          if (isValid) {
            let refCom = this.$vueRefStore.getChildrenRef("studentSelector");
            if (!!refCom) {
              isValid = refCom.validate();
            }
          }

          callback(isValid);
        });
      } else {
        callback(true);
      }
    },
  },
};

export default {
  name: "emailVideoEditor",
  mixins: [mixinGeneralMethods],
  components: {
    studentSelector: () => import("./studentSelector.vue"),
    sproutVideoUpload: () => import("@/components/sproutVideo/videoUpload"),
    aliyunVodUpload: () => import("@/components/aliyunVod/videoUpload"),
    aliyunVideoPlayer: () => import("@/components/aliyunVod/aliyunVideoPlayer"),
    blobUploader: () => import("@/components/fileHandler/blobUploader"),
  },
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "50%",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    courseType: {
      type: Number,
      default: undefined,
    },
    courseKey: {
      type: String,
      default: undefined,
    },
    emailVideoId: {
      type: Number,
      default: null,
    },
    type: {
      type: Number,
      default: 0,
      validator: (value) => [0, 1].contains(value), //0: 编辑 1: 重发
    },
  },
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  data() {
    // 检查该课程下是否已存在相同标题的邮件视频 (未启用)
    // let validateTitle = async (rule, value, callback) => {
    //   var isExist = await this.isEmailVideoTitleExistFromServer();
    //   if (isExist) {
    //     callback("该课程下已存在相同标题的邮件视频");
    //     return;
    //   }

    //   callback();
    // };

    return {
      isUploading: false,
      isSaving: false,
      dialogVisible: false,
      coursewareUploaderVisible: false,
      EmailVideoContentCategory,
      contentCategoryOptions: [
        {
          value: EmailVideoContentCategory.GradedOrExam,
          label: "学校算分的项目或者考试相关内容",
        },
        {
          value: EmailVideoContentCategory.DailyPractice,
          label: "日常练习或者知识点补充",
        },
      ],
      rules: {
        Title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
          {
            max: 500,
            message: "标题不可超过500个字符",
            trigger: "blur",
          },
          // {
          //   validator: validateTitle,
          //   trigger: "blur",
          // },
        ],
        ContentCategory: [
          {
            required: true,
            message: "请选择内容类别",
            trigger: "change",
          },
        ],
        ExpirationTime: [
          {
            validator: (rule, value, callback) => {
              if (
                this.model.ContentCategory ===
                  EmailVideoContentCategory.GradedOrExam &&
                !value
              ) {
                callback(new Error("算分/考试相关内容必须设置过期时间"));
                return;
              }
              callback();
            },
            trigger: "change",
          },
        ],
        CourseType: [
          {
            required: true,
            message: "请选择课程类型",
            trigger: "blur",
          },
        ],
        CourseKey: [
          {
            required: true,
            message: "请选择课程",
            trigger: "blur",
          },
        ],
      },
      model: new EmailVideo(),
      sproutVideoUploadVisible: false,
      sproutVideoViewVisible: false,
      sproutVideoFile: null,
      sproutVideoUploadData: {
        courseId: 0,
        title: null,
        fileId: null,
      },
      aliyunVodUploadVisible: false,
      aliyunVodUploadData: {
        courseActivationId: 0,
        courseId: 0,
        title: null,
        fileId: null,
      },
      aliyunVideoViewVisible: false,
      aliyunVideoInfo: null,
      isAliyunVideoPlayerPlay: false,
      hideAliyunVideoPlayerError: true
    };
  },
  created() {
    this.init();
    this.reloadVisible();
  },
  computed: {
    isResending() {
      return !!this.emailVideoId && this.type === 1;
    },
    isEdit() {
      return !!this.emailVideoId && this.type === 0;
    },
    dialogWidth() {
      return this.activeStep === 0 ? "70%" : this.width;
    },
    titlePrefix() {
      if (this.isResending) return "重发";
      if (this.isEdit) return "编辑";
      return "添加";
    },
  },
  methods: {
    // 和服务端进行数据交互相关方法
    async getEmailVideoFromServer() {
      if (!this.emailVideoId) return null;

      try {
        let result = await getEmailVideo(this.emailVideoId);
        if (!!result && result.success) {
          return result.data;
        }
      } catch (error) {
        console.error(error);
      }

      return null;
    },
    async getSproutVideoFileFromServer() {
      try {
        let result = await getSproutVideoFile(this.model.VideoFileId);
        if (!!result && result.success) {
          this.sproutVideoFile = result.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getAliyunVodVideoInfoFromServer() {
      try {
        let result = await getAliyunVodVideoInfo(this.model.VideoFileId);
        if (!!result && result.success) {
          this.aliyunVideoInfo = result.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async isEmailVideoTitleExistFromServer() {
      try {
        let result = await isEmailVideoTitleExist(
          this.model.CourseId,
          this.model.Title,
          this.model.Id
        );
        if (!!result && result.success) {
          return result.data;
        }
      } catch (error) {
        console.error(error);
      }

      return false;
    },
    onContentCategoryChange(value) {
      if (value !== EmailVideoContentCategory.GradedOrExam) {
        this.model.ExpirationTime = null;
      }
    },
    async saveEmailVideoToServer() {
      this.isSaving = true;

      try {
        if (
          this.model.ContentCategory !== EmailVideoContentCategory.GradedOrExam
        ) {
          this.model.ExpirationTime = null;
        }
        let result = await saveEmailVideo(this.model);
        if (!!result && result.success) {
          this.model.Id = result.data;

          this.$message({
            message: "保存成功",
            type: "success",
          });

          this.$emit("change", this.model);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isSaving = false;
      }
    },
    async resendEmailVideoToServer() {
      this.isSaving = true;

      let studentIds = this.model.Students.filter(
        (item) => !item.HasBeenSent
      ).map((item) => item.StudentId);
      try {
        let result = await resendEmailVideo(this.model.Id, studentIds);
        if (!!result && result.success) {
          this.$message({
            message: "重发成功",
            type: "success",
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isSaving = false;
      }
    },

    init() {},
    reloadVisible(newValue = this.visible) {
      if (this.dialogVisible === newValue) return;

      this.dialogVisible = newValue;
      if (this.dialogVisible) this.reloadDataFromProps();
    },
    resetData() {
      this.activeStep = 0;
      this.model = new EmailVideo();

      this.sproutVideoUploadVisible = false;
      this.sproutVideoViewVisible = false;
      this.sproutVideoFile = null;
      this.sproutVideoUploadData = {
        courseId: 0,
        title: null,
        fileId: null,
      };

      this.aliyunVodUploadVisible = false;
      this.aliyunVideoViewVisible = false;
      this.aliyunVideoInfo = null;
      this.aliyunVodUploadData = {
        courseActivationId: 0,
        courseId: 0,
        title: null,
        fileId: null,
      };
      this.isAliyunVideoPlayerPlay = false;

      this.$nextTick(() => {
        let refCom = this.$vueRefStore.getChildrenRef("studentSelector");
        if (!!refCom) {
          refCom.resetData();
        }
      });
    },
    async reloadDataFromProps() {
      if (!this.dialogVisible) return;

      let data = await this.getEmailVideoFromServer();
      this.model = new EmailVideo();
      if (!!data) this.model.updateByBackendData(data);
      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.resetFields();
      }

      if (!!this.model.Id) {
        switch (this.model.VideoPlatform) {
          case this.GLOBAL.enumVideoPlatform.AliyunVod:
            this.getAliyunVodVideoInfoFromServer();
            break;
          default:
            this.getSproutVideoFileFromServer();
            break;
        }
      }

      this.$nextTick(async () => {
        let refCom = this.$vueRefStore.getChildrenRef("studentSelector");
        if (!!refCom) {
          await refCom.init();
          refCom.reloadDataFromProps();
        }
      });
    },
    showDialog() {
      this.dialogVisible = true;
      this.$emit("update:visibleChange", this.dialogVisible);
    },
    async closeDialog() {
      this.resetData();
      this.dialogVisible = false;
      this.$emit("update:visibleChange", this.dialogVisible);
    },
    onDialogOpen() {
      this.reloadDataFromProps();
    },
    handleClose(done) {
      this.$nextTick(async () => {
        this.closeDialog();
      });
    },
    saveChanges() {
      this.validateAsync((isValid) => {
        if (!isValid) return;

        let uploadedVideo = false;
        switch (this.model.VideoPlatform) {
          case this.GLOBAL.enumVideoPlatform.AliyunVod:
            uploadedVideo = !!this.aliyunVideoInfo;
            break;
          default:
            uploadedVideo = !!this.sproutVideoFile;
            break;
        }

        isValid = uploadedVideo || this.model.Files.length > 0;
        if (!isValid) {
          this.$message.error("请上传视频或课件");
          return;
        }

        this.$nextTick(async () => {
          await this.saveEmailVideoToServer();
          this.closeDialog();
        });
      });
    },
    doResendEmailVideo() {
      this.validateAsync((isValid) => {
        if (!isValid) return;

        this.$nextTick(async () => {
          await this.resendEmailVideoToServer();
          this.closeDialog();
        });
      });
    },
    onVideoUploadClick() {
      this.validateAsync((isValid) => {
        if (!isValid) return;

        if (
          this.model.VideoPlatform === this.GLOBAL.enumVideoPlatform.AliyunVod
        ) {
          this.aliyunVodUploadData = {
            courseActivationId: this.model.CourseActivationId,
            courseId: this.model.CourseId,
            title: this.model.Title,
            fileId: this.model.VideoFileId,
          };
          this.aliyunVodUploadVisible = true;
        } else {
          this.sproutVideoUploadData = {
            courseId: this.model.CourseId,
            title: this.model.Title,
          };
          this.sproutVideoUploadVisible = true;
        }
      });
    },
    closeVideoUpload() {
      if (
        this.model.VideoPlatform === this.GLOBAL.enumVideoPlatform.AliyunVod
      ) {
        this.aliyunVodUploadVisible = false;
      } else {
        this.sproutVideoUploadVisible = false;
      }
    },
    onVideoUploadSuccess(fileName, courseActivationId, fileId) {
      this.model.VideoFileId = fileId;
      this.isUploading = false;

      this.$nextTick(() => {
        switch (this.model.VideoPlatform) {
          case this.GLOBAL.enumVideoPlatform.AliyunVod:
            this.getAliyunVodVideoInfoFromServer();
            break;
          default:
            this.getSproutVideoFileFromServer();
            break;
        }
      });

      setTimeout(() => {
        this.closeVideoUpload();
      }, 3000);
    },
    onFileUploadError() {
      this.isUploading = false;
    },
    onBeforeUpload() {
      this.isUploading = true;
    },
    onBeforeClose(done) {
      if (!this.isUploading) {
        this.closeVideoUpload();
      }
    },
    onVideoView() {
      switch (this.model.VideoPlatform) {
        case this.GLOBAL.enumVideoPlatform.AliyunVod:
          this.aliyunVideoViewVisible = true;
          break;
        default:
          this.sproutVideoViewVisible = true;
          break;
      }
    },
    closeUploader() {
      this.coursewareUploaderVisible = false;
    },
    uploadFile() {
      this.coursewareUploaderVisible = true;
    },
    onUploaded(data) {
      if (!!data) {
        data.forEach((item) => {
          this.model.Files.push({
            FileStorageId: item.FileId,
            FileName: item.FileName,
            CreateTime: moment().format("YYYY/MM/DD HH:mm"),
          });
        });
        this.errorMessage = "";
        this.showError = false;
      }
      this.coursewareUploaderVisible = false;
    },
    onUploadError() {},
    onCloseUploader() {},
    removeFile(file) {
      this.$confirm("您确认要删除该课件文件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var index = this.model.Files.findIndex((item) => {
            if (item.FileStorageId == file.FileStorageId) {
              return true;
            }
          });
          this.model.Files.splice(index, 1);
        })
        .catch(() => {});
    },
    downloadEmailFile(fileId) {
      getBlobFileUrlById(fileId)
        .then((result) => {
          if (!!result && result.success) {
            let { Url, FileName } = result.data;
            downloadFileToBlob(Url, 0).then((res) => {
              if (!!res && !!res.data)
                downloadFile({ data: res.data, filename: FileName });
              else this.$message.error("未能正确获取到文件数据。");
            });
          } else {
            if (!!result.message) {
              this.$message.error(result.message);
            }
          }
        })
        .catch(() => {});
    },

    onCloseAliyunVideo() {
      this.aliyunVideoViewVisible = false;
      this.isAliyunVideoPlayerPlay = false;
    },
    onAliyunVideoPlayerPlay(e) {
      if (
        this.activeTab === "2" &&
        this.currentEventData &&
        this.currentEventData.row &&
        this.currentEventData.row.IsAppointment &&
        this.pauseTime
      ) {
        let currentTime = new Date();
        let validTime = new Date(Date.parse(this.pauseTime));
        let validMinutes = 5;
        validTime.setMinutes(validTime.getMinutes() + validMinutes);
        if (currentTime > validTime) {
          this.pauseTime = null;
          this.clearTimer();
          this.$refs.appointmentList.customEventHandler(this.currentEventData);
          return;
        }
      }
      this.isAliyunVideoPlayerPlay = true;
      this.pauseTime = null;
    },
    onAliyunVideoPlayerPause(e) {
      this.isAliyunVideoPlayerPlay = false;
      this.pauseTime = new Date();
    },
  },
  watch: {
    visible(newValue) {
      this.reloadVisible(newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog__wrapper {
  /deep/ .editor-dialog {
    min-width: 400px;

    .el-dialog__header {
      font-size: 1.75em;
      font-weight: bold;
    }
  }

  .dialog-footer {
    .footer-left {
      text-align: left;
    }

    .footer-right {
      text-align: right;
    }

    margin-top: 0;
  }
}

.cs-editor-content {
  padding: 0 5%;

  .el-form {
    .el-form-item {
      margin-bottom: 12px;

      .input-width {
        width: 100%;
      }
    }
  }
}

.cs-emailVideoEditor-file {
  line-height: 30px;
  height: 30px;
}

.cs-emailVideoEditor-expirationHint {
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 4px;
}
</style>

<style lang="scss">
.cs-sproutVideo-container,
.cs-aliyunVideo-container {
  .el-dialog__headerbtn {
    top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emailVideo/emailVideoEditor.vue